import { Grid, Group, MantineSize, Stack, Text } from "@mantine/core"
import { LabelWithTooltip } from "@tfg/ui"
import { ReactNode } from "react"

type Props = {
  label: string
  size?: MantineSize
  bold?: boolean
  value?: string | ReactNode | null
  helpText?: string
  maxWidth?: string
}

export const Property = ({
  label,
  value,
  bold,
  size = "xs",
  helpText,
  maxWidth = "100%",
}: Props) => {
  return (
    <Stack gap="xs" align="flex-start" maw={maxWidth}>
      <Grid justify="space-between" w="100%">
        <Grid.Col span={8}>
          <LabelWithTooltip label={label} hoverHelperText={helpText} />
        </Grid.Col>
        <Grid.Col span={4}>
          <PropertyValue value={value} size={size} bold={bold} />
        </Grid.Col>
      </Grid>
    </Stack>
  )
}

const PropertyValue = ({
  value,
  size,
  bold,
}: {
  value: string | ReactNode | null
  size: MantineSize
  bold?: boolean
}) => {
  if (!value) {
    value = "-"
  }
  if (typeof value === "string") {
    return (
      <Group align="center" justify="flex-end" w="100%">
        <Text size={size} fw={bold ? "bold" : "normal"}>
          {value}
        </Text>
      </Group>
    )
  }
  return value
}
